var mountElement = document.querySelector('#size-calculator-app');
var app = new Vue({
  el: '#size-calculator-app',
  data() {
    return {
      availableSizes: mountElement.getAttribute('size-options').split('|'),
      optionName: mountElement.getAttribute('option-name'),
      showingResults: false,

      unit: 'inches',
      form: {},
      title: 'Size calculator',
      intro: 'Use this size calculator to discover the perfect pump for you. Learn how to correctly measure yourself',
      recommendation: {},
      selectedSize: null,
      showingSizeGuide: false,
      productDetails: {
        'V3': {
          title: 'VaxAid Deluxe V3',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V3_38fcf82e-add0-4ab9-8110-8d39dc7af48c.png?v=1747939714',
          length: 'Supports 3" / 7.5cm',
          girth: 'Supports up to 6" / 15.5cm'
        },
        'V5': {
          title: 'VaxAid Deluxe V5',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V5.png?v=1747939714',
          length: 'Supports 3”-5” / 7.5-12.5cm',
          girth: 'Supports up to 6” / 15.5cm'
        },
        'V6': {
          title: 'VaxAid Deluxe V6',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V6.png?v=1747939714',
          length: 'Supports 6" / 15cm',
          girth: 'Supports up to 6.5" / 16.5cm'
        },
        'V7': {
          title: 'VaxAid Deluxe V7',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V7_a263c6e7-8ab8-42da-bd0f-6ca630b5fd10.png?v=1747939714',
          length: 'Supports 5”-7” / 12.5-17.5cm',
          girth: 'Supports up to 6.5” / 16.5cm'
        },
        'V7+': {
          title: 'VaxAid Deluxe V7+',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V7.png?v=1747939713',
          length: 'Supports 5”-7” / 12.5-17.5cm',
          girth: 'Supports up to 7.5” / 19cm'
        },
        'V7 Plus': {
          title: 'VaxAid Deluxe V7 Plus',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V7.png?v=1747939713',
          length: 'Supports 5”-7” / 12.5-17.5cm',
          girth: 'Supports up to 7.5” / 19cm'
        },
        'V8': {
          title: 'VaxAid Deluxe V8',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V8.png?v=1747939714',
          length: 'Supports 8" / 20cm',
          girth: 'Supports up to 7" / 17.5cm'
        },
        'V9': {
          title: 'VaxAid Deluxe V9',
          image: 'https://cdn.shopify.com/s/files/1/0024/7549/1375/files/V9.png?v=1747939714',
          length: 'Supports 7”-9” / 17.5-23cm',
          girth: 'Supports up to 7.5” / 19cm'
        }
      } 
    }; 
  },
  computed: {
    isFormValid() {
      return (this.form.length && this.form.length > 0) && (this.form.girth && this.form.girth > 0);
    },
    matchedSizes() {
      if (!this.form.length && !this.form.girth) {
        return this.availableSizes;
      }

      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      return this.availableSizes.filter((size) => {
        const sizeValue = this.mapSizeToValue(size);

        if (lengthValue <= 3) {

if (girthValue <= 6) {
          return [3].includes(sizeValue);
}

if (girthValue <= 6.5) {
          return [6].includes(sizeValue);
}

}

if (lengthValue < 3.5) {

if (girthValue <= 6) {
          return [3,5].includes(sizeValue);
}

if (girthValue <= 6.5) {
          return [6].includes(sizeValue);
}

}

if (lengthValue < 5) {

if (girthValue <= 6) {
          return [5].includes(sizeValue);
}

if (girthValue <= 6.5) {
          return [6].includes(sizeValue);
}

}

if (lengthValue < 5.5) {

if (girthValue <= 6) {
          return [5,6].includes(sizeValue);
}
if (girthValue <= 6.5) {
          return [6].includes(sizeValue);
}

}


if (lengthValue < 6) {

if (girthValue <= 6.5) {
          return [6].includes(sizeValue);
}
if (girthValue <= 7) {
          return [8].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return ['7+'].includes(sizeValue);
}


}

if (lengthValue < 6.5) {

if (girthValue <= 6.5) {
          return [6,7].includes(sizeValue);
}
if (girthValue <= 7) {
          return ['7+',8].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return ['7+'].includes(sizeValue);
}


}

if (lengthValue < 7) {

if (girthValue <= 6.5) {
          return [7].includes(sizeValue);
}
if (girthValue <= 7) {
          return ['7+',8].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return ['7+'].includes(sizeValue);
}


}

if (lengthValue < 7.5) {

if (girthValue <= 6.5) {
          return [7,8].includes(sizeValue);
}
if (girthValue <= 7) {
          return ['7+',8].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return ['7+'].includes(sizeValue);
}


}

if (lengthValue < 8) {

if (girthValue <= 7) {
          return [8].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return [9].includes(sizeValue);
}


}

if (lengthValue < 8.5) {

if (girthValue <= 7) {
          return [8,9].includes(sizeValue);
}
if (girthValue <= 7.5) {
          return [9].includes(sizeValue);
}


}

if (lengthValue < 9.5) {

if (girthValue <= 7.5) {
          return [9].includes(sizeValue);
}


}

        return false;
      }).sort();
    }
  },
  methods: {
    getResults() {
      this.setRecommendation();
      this.showingResults = true;
    },
    setRecommendation() {
    // Always use the first matched size as the primary recommendation
    this.recommendation = this.matchedSizes.length ? this.matchedSizes[0] : '';
  },
    setUnit(unit) {
      this.unit = unit;
    },
    setSize(size) {
      this.selectedSize = size;

      const input = document.querySelector(`[name="${this.optionName}"][value="${size}"]`);
      input.click();
    },
    mapSizeToValue(size) {
    const num = parseFloat(size.replace(/\D/g, ''));
    return (size.includes('+') || /plus/i.test(size)) ? `${num}+` : num;
  },
    restart() {
      this.form = {};
      this.showingResults = false;
    },
    complete() {
      document.querySelector('#ModalClose-sizeCalculator').click();
    },
    toggleSizeGuide() {
      this.showingSizeGuide = !this.showingSizeGuide;
    },
    hideSizeGuide() {
      this.showingSizeGuide = false;
    }
  },
  mounted() {
    document.body.addEventListener('modalClosed', this.hideSizeGuide);
  },
  unmounted() {
    document.body.removeEventListener('modalClosed', this.hideSizeGuide);
  },
  delimiters: ['${', '}'],
})